import React from 'react'
import 'leaflet/dist/leaflet.css'
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
} from '@chakra-ui/react'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { divIcon} from 'leaflet'
import { useDisclosure } from '@chakra-ui/hooks'
const svgIcon = divIcon({
	html: `
	<svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M6.72922 19.5965C1.05352 11.3684 0 10.5239 0 7.5C0 3.35785 3.35785 0 7.5 0C11.6421 0 15 3.35785 15 7.5C15 10.5239 13.9465 11.3684 8.27078 19.5965C7.89832 20.1345 7.10164 20.1345 6.72922 19.5965ZM7.5 10.625C9.2259 10.625 10.625 9.2259 10.625 7.5C10.625 5.7741 9.2259 4.375 7.5 4.375C5.7741 4.375 4.375 5.7741 4.375 7.5C4.375 9.2259 5.7741 10.625 7.5 10.625Z" fill="#009B76"/>
	</svg>`,
	className: "",
	iconSize: [35, 35],
  });
// const myIcon = new Icon({
// 	iconUrl: marker,
// 	iconSize: [35, 35],
// })
const Mapcomponent = ({ lat, lng, setMapOpenStatus }) => {
	const { isOpen, onClose } = useDisclosure()

	const position = [lat, lng]

	const onpopClose = () => {
		setMapOpenStatus(false)
		onClose()
	}
	return (
		<Modal isOpen={true} onClose={onpopClose} size={'lg'}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader></ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<MapContainer
						center={position}
						zoom={13}
						attributionControl={false}
						scrollWheelZoom={false}
						//zoomControl={false}
					>
						<TileLayer
							attribution='<a href="https://www.openstreetmap.org/copyright"></a>'
							url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
						/>
						<Marker position={position} icon={svgIcon}></Marker>
					</MapContainer>
				</ModalBody>
			</ModalContent>
		</Modal>
	)
}

export default Mapcomponent
